// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__37XJa","selects":"Documents_selects__1FleC"};